import { navigateToUrl } from 'single-spa';
export var navigateWithParams = (url, extraParams) => {
  var queryParams = window.location.search;
  var goToUrl = url + (queryParams || '?');
  if (extraParams && extraParams.startsWith('&')) goToUrl = goToUrl + extraParams;else if (extraParams) goToUrl = "".concat(goToUrl, "&").concat(extraParams);
  navigateToUrl(goToUrl);
};
export var getQueryParams = () => {
  var queryString = window.location.search;
  return new URLSearchParams(queryString);
};
export default getQueryParams;
//# sourceMappingURL=index.js.map